import axios from 'axios';

import {configHeaders} from '../utils/configHeaders';

export const createCompany = async (company) => {
  try {
    const {data} = await axios.post(
      `${process.env.REACT_APP_SERVER_URL}/api/companies`,
      {
        company,
      },
      await configHeaders()
    );

    return data;
  } catch (error) {
    return {error: error.response.data};
  }
};

export const getCompany = async (id) => {
  try {
    const {data} = await axios.get(
      `${process.env.REACT_APP_SERVER_URL}/api/companies/${id}`,
      await configHeaders()
    );

    return data;
  } catch (error) {
    return {error: error.response.data};
  }
};

export const getCompanies = async () => {
  try {
    const {data} = await axios.get(
      `${process.env.REACT_APP_SERVER_URL}/api/companies`,
      await configHeaders()
    );

    return data;
  } catch (error) {
    return {error: error.response.data};
  }
};

export const updateApiKey = async (id, dispatch) => {
  try {
    const {data} = await axios.put(
      `${process.env.REACT_APP_SERVER_URL}/api/companies/${id}/apikey`,
      id,
      await configHeaders()
    );

    dispatch({type: 'UPDATE_API_KEY', payload: data.apiKey});

    return data;
  } catch (error) {
    return {error: error.response.data};
  }
};

export const updateCompany = async (companyId, company) => {
  try {
    const {data} = await axios.put(
      `${process.env.REACT_APP_SERVER_URL}/api/companies/${companyId}`,
      company,
      await configHeaders()
    );
    return data;
  } catch (error) {
    return {error: error.response.data};
  }
};

export const archivedCompany = async (id, isArchivedValue, formattedServices) => {
  try {
    const {data} = await axios.put(
      `${process.env.REACT_APP_SERVER_URL}/api/companies/${id}/archived`,
      {
        isArchivedValue,
        formattedServices,
      },
      await configHeaders()
    );
    return data;
  } catch (error) {
    return {error: error.response.data};
  }
};
